export const profileLeavesTabStyles = {
  tabBarContainer: {
    mb: 0,
    px: 0,
  },
  tabsBar: {
    mb: 0,
    minHeight: 38,
    borderBottom: '2px solid #e0e0e0',
    bgcolor: 'background.paper',
    px: 0,
  },
  tab: active => ({
    minHeight: 38,
    minWidth: 90,
    fontWeight: active ? 700 : 500,
    fontSize: '1.01rem',
    color: active ? '#1976d2' : '#757575',
    textTransform: 'none',
    letterSpacing: 0.1,
    px: 2,
    py: 0.5,
    mx: 0.5,
    borderRadius: '10px 10px 0 0',
    bgcolor: active ? 'rgba(25,118,210,0.07)' : 'transparent',
    transition: 'all 0.15s',
    '&:hover': {
      bgcolor: 'rgba(25,118,210,0.10)',
      color: '#1976d2',
    },
  }),
  tabLabel: active => ({
    display: 'flex',
    alignItems: 'center',
    gap: 0.7,
    fontWeight: active ? 700 : 500,
  }),
  tabCount: active => ({
    display: 'inline-block',
    minWidth: 22,
    height: 22,
    px: 1,
    ml: 0.5,
    fontSize: '0.93rem',
    fontWeight: 700,
    color: active ? '#fff' : '#1976d2',
    bgcolor: active ? '#1976d2' : 'rgba(25,118,210,0.10)',
    borderRadius: '12px',
    lineHeight: 1.7,
    textAlign: 'center',
    transition: 'all 0.15s',
  }),
  tabIndicator: {
    height: 3,
    borderRadius: 2,
    bgcolor: '#1976d2',
  },
  statusChip: status => ({
    bgcolor:
      status === 'APPROVED'
        ? '#43a047'
        : status === 'GROUP_MANAGER_APPROVED'
          ? '#9c27b0'
          : status === 'TEAM_MANAGER_APPROVED'
            ? '#2196f3'
            : status === 'PENDING'
              ? '#ff9800'
              : status === 'REJECTED'
                ? '#d32f2f'
                : '#757575',
    color: '#fff',
    fontWeight: 600,
    fontSize: '0.93rem',
    px: 1,
    py: 0.2,
    borderRadius: '10px',
    minWidth: 20,
    textAlign: 'center',
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.07)',
    letterSpacing: 0.1,
    lineHeight: 1.7,
    pointerEvents: 'none',
    cursor: 'default',
  }),
};
